import {
  type AllocationConstraintsInput,
  type AllocationConstraintsOutput,
  schema as allocationConstraintsSchema,
} from '../allocationConstraints/AllocationConstraintsStep.validation.ts';
import {
  type AssetUniverseStepInput,
  type AssetUniverseStepOutput,
  schema as assetUniverseSchema,
} from '../asset/assetUniverse/AssetUniverseStep.validation.ts';
import {
  type RiskBudgetInput,
  type RiskBudgetOutput,
  riskBudgetSchema,
} from '../assumptionsAndOutlook/AssumptionsAndOutlook.validation.tsx';
import {
  type DescriptionStepInput,
  type DescriptionStepOutput,
  schema as descriptionSchema,
} from '../description/DescriptionStep.validation.ts';
import {
  type ObjectivesStepInput,
  type ObjectivesStepOutput,
  createSchema as createObjectivesSchema,
} from '../objective/ObjectivesStep.validation.ts';
import {
  type PortfolioConstraintsStepOutput,
  type PortfolioLevelConstraintsStepInput,
  createSchema as createPortfolioConstraintSchema,
} from '../portfolioConstraints/PortfolioConstraintsStep.validation.ts';
import { secondaryConstraintQuantityValues } from '../portfolioConstraints/PortfolioSecondaryConstraint.validation.ts';

export type PortfolioDefinitionWithAssetUniverseOutputFields = DescriptionStepOutput &
  ObjectivesStepOutput<false> &
  PortfolioConstraintsStepOutput &
  AssetUniverseStepOutput &
  AllocationConstraintsOutput &
  RiskBudgetOutput;

export type PortfolioDefinitionWithAssetUniverseInputFields = DescriptionStepInput &
  ObjectivesStepInput<false> &
  PortfolioLevelConstraintsStepInput &
  AllocationConstraintsInput &
  AssetUniverseStepInput &
  RiskBudgetInput;

export const schema = descriptionSchema
  .concat(createObjectivesSchema(false))
  .concat(createPortfolioConstraintSchema(secondaryConstraintQuantityValues))
  .concat(assetUniverseSchema)
  .concat(allocationConstraintsSchema)
  .concat(riskBudgetSchema);
